module.exports = __webpack_public_path__ + "img/togocel.70a17722.png";